import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case03.about-the-artist-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  bioGerrietTitle: {
    id: `${PREFIX}.bio.gerriet.title`,
  },
  bioGerrietDescription: {
    id: `${PREFIX}.bio.gerriet.description`,
  },
  bioGerrietLink: {
    id: `${PREFIX}.bio.gerriet.link`,
  },
  galleryItem1Description: {
    id: `${PREFIX}.gallery.item1.description`,
  },
  galleryItem2Description: {
    id: `${PREFIX}.gallery.item2.description`,
  },
  galleryItem3Description: {
    id: `${PREFIX}.gallery.item3.description`,
  },
  galleryItem4Description: {
    id: `${PREFIX}.gallery.item4.description`,
  },
});
